import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';

export const query = gql`
  query GetUserDetailStatsAdmin($input: GetUserDetailStatsAdminInput!) {
    getUserDetailStatsAdmin(input: $input) {
      avgOrderValue {
        value
        change
        changeText
        isPositive
      }
      totalOrders {
        value
        change
        changeText
        isPositive
      }
      spentYTD {
        value
        change
        changeText
        isPositive
      }
      attendanceRate {
        value
        change
        changeText
        isPositive
      }
      eventsAttendedYTD {
        value
        change
        changeText
        isPositive
      }
    }
  }
`;

export default graphql(query, {
  options: ({ match }) => {
    return {
      variables: {
        input: {
          user_id: Number(match.params.id),
        },
      },
      fetchPolicy: 'cache-and-network',
    };
  },
  name: 'statsData', // Use a different name to avoid conflicts with transaction data
});
